const NotoNaskhArabicCustomAEDSAR = 'NotoNaskhArabic-Custom-AED-SAR';
const InterCustomAEDSAR = 'Inter-Custom-AED-SAR';

// Determine currency
const currencyCodeCookie = document.cookie
  .split('; ')
  .find((row) => row.startsWith('wego_currency='))
  ?.split('=')[1];

const isAEDCurrency =
  currencyCodeCookie === 'AED' ||
  (!currencyCodeCookie &&
    (window.location.hostname.includes('wego.ae') || window.location.hostname.startsWith('ae-')));

const isSARCurrency =
  currencyCodeCookie === 'SAR' ||
  (!currencyCodeCookie &&
    (window.location.hostname.includes('wego.sa') || window.location.hostname.startsWith('sa-')));

// Determine locale
const localeCookie = document.cookie
  .split('; ')
  .find((row) => row.startsWith('wego_locale='))
  ?.split('=')[1];
const localeParam = window.location.pathname.split('/')[1];
const localeSearchParam = new URLSearchParams(window.location.search).get('ulang');

const isArLocale = localeSearchParam === 'ar' || localeParam === 'ar' || localeCookie === 'ar';

// Load fonts
const preloadCustomFont = (font) => {
  const customFont = document.createElement('link');
  customFont.rel = 'preload';
  customFont.href = `https://zen.wego.com/web/fonts/${font}.woff`;
  customFont.as = 'font';
  customFont.type = 'font/woff';
  customFont.crossOrigin = '';
  document.head.appendChild(customFont);
};

const loadCustomFont = (font) => {
  const style = document.createElement('style');
  style.textContent = `
    @font-face {
      font-family: '${font}';
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url('https://zen.wego.com/web/fonts/${font}.woff') format('woff');
    }
    `;

  document.head.appendChild(style);
};

const lazyLoadCustomFont = (font) => {
  window.addEventListener('load', () => {
    loadCustomFont(font);
  });
};

if (isAEDCurrency || isSARCurrency) {
  const [imperativeCustomFont, lazyCustomFont] = isArLocale
    ? [NotoNaskhArabicCustomAEDSAR, InterCustomAEDSAR]
    : [InterCustomAEDSAR, NotoNaskhArabicCustomAEDSAR];

  preloadCustomFont(imperativeCustomFont);
  document.addEventListener('DOMContentLoaded', () => loadCustomFont(imperativeCustomFont));
  lazyLoadCustomFont(lazyCustomFont);
} else {
  lazyLoadCustomFont(InterCustomAEDSAR);
  lazyLoadCustomFont(NotoNaskhArabicCustomAEDSAR);
}
